import Flex from 'typescript-styled-flex'
import styled, { ITheme } from '../../../../theme'
import { IWithSize } from '../../../../containers/BookingCalendar/Calendar/Calendar'

const IconWrapper = styled(Flex as any)<IWithSize>`
  cursor: pointer;
  width: ${({ size }) => (size ? 42 * size : 42)}px;
  min-width: ${({ size }) => (size ? 42 * size : 42)}px;
  min-height: ${({ size }) => (size ? 42 * size : 42)}px;
  height: ${({ size }) => (size ? 42 * size : 42)}px;
  margin-left: ${({ size }) => (size ? 15 * size : 15)}px;
  border-radius: 50%;

  &:hover {
    background-color: ${(props: ITheme) => props.theme.colors.palette.paleGrey};
  }
`

export default IconWrapper
